export default __webpack_public_path__ + "static/media/yellow_checkbox.92d80ffd.svg";